import React from 'react'

const CalendarClockIcon = (props) => {
  const { width = 20, height = 20, fill = '#A8A8A8' } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3319_277"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width}
        height={height}
      >
        <rect width={width} height={height} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3319_277)">
        <path
          d="M4.16667 6.66699H15.8333V5.00033H4.16667V6.66699ZM4.16667 18.3337C3.70833 18.3337 3.31597 18.1705 2.98958 17.8441C2.66319 17.5177 2.5 17.1253 2.5 16.667V5.00033C2.5 4.54199 2.66319 4.14963 2.98958 3.82324C3.31597 3.49685 3.70833 3.33366 4.16667 3.33366H5V1.66699H6.66667V3.33366H13.3333V1.66699H15V3.33366H15.8333C16.2917 3.33366 16.684 3.49685 17.0104 3.82324C17.3368 4.14963 17.5 4.54199 17.5 5.00033V9.72949C17.2361 9.60449 16.9653 9.50033 16.6875 9.41699C16.4097 9.33366 16.125 9.27116 15.8333 9.22949V8.33366H4.16667V16.667H9.41667C9.51389 16.9725 9.62847 17.2642 9.76042 17.542C9.89236 17.8198 10.0486 18.0837 10.2292 18.3337H4.16667ZM15 19.167C13.8472 19.167 12.8646 18.7607 12.0521 17.9482C11.2396 17.1357 10.8333 16.1531 10.8333 15.0003C10.8333 13.8475 11.2396 12.8649 12.0521 12.0524C12.8646 11.2399 13.8472 10.8337 15 10.8337C16.1528 10.8337 17.1354 11.2399 17.9479 12.0524C18.7604 12.8649 19.1667 13.8475 19.1667 15.0003C19.1667 16.1531 18.7604 17.1357 17.9479 17.9482C17.1354 18.7607 16.1528 19.167 15 19.167ZM16.3958 16.9795L16.9792 16.3962L15.4167 14.8337V12.5003H14.5833V15.167L16.3958 16.9795Z"
          fill={fill}
        />
      </g>
    </svg>
  )
}

export default CalendarClockIcon
